export const AssetTypeDetailsStyles = {
    assetImageContainer: 'flex justify-center flex-col items-center w-full sm:max-w-1xl',
    assetImage: 'object-contain',
    assetName: 'text-xl text-center text-goEasyBlue400 font-montserrat font-semibold sm:text-4xl',
    imageContainer: 'max-w-1xl',
    assetDetailsHeader: 'flex flex-row items-center gap-x-2 sm:gap-x-4 mb-1',
    vendorLogoContainer: 'h-12 flex items-center sm:h-16',
    vendorLogo: 'h-full w-auto object-contain mx-auto',
    assetNameContainer: 'mt-1'
}